import { FieldSpec, getEnumValuesFromMap } from 'lib/rich'

const unitEnumValues = getEnumValuesFromMap({
  in: 'Inches',
  mm: 'Millimeters',
})

export const unit_spec: FieldSpec = {
  title: 'Unit',
  kind: 'enum',
  enumValues: unitEnumValues,
  defaultValueIN: 'in',
  defaultValueMM: 'mm',
  required: true,

  hidden: true,
}
